import { FC, useMemo, type JSX } from 'react';

import StatusBadge from '@payaca/components/statusBadge/StatusBadge';
import { getJobStatusBadgeState } from '@payaca/helpers/jobHelperV2';
import { ReadableJobStatus } from '@payaca/types/jobTypes';

type Props = {
  status?: ReadableJobStatus;
};

const JobStatusBadge: FC<Props> = ({ status }: Props): JSX.Element | null => {
  const state = useMemo(() => getJobStatusBadgeState(status), [status]);

  if (!status) return null;

  const label = status === ReadableJobStatus.INACTIVE ? 'Cancelled' : status;

  return <StatusBadge state={state}>{label}</StatusBadge>;
};

export default JobStatusBadge;
